module.exports = __webpack_public_path__ + "static/img/background.81156fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/715/background.png
// module id = 493
// module chunks = 1